module.exports = __webpack_public_path__ + "img/personalization.83c85a00.svg";